export default {
  namespaced: true,
  state: {
    category: [
      { name: '-', value: 0 },
      { name: 'Memo', value: 1 },
      { name: 'Manual', value: 2 },
      { name: 'Other', value: 3 },
      { name: 'AD', value: 4 },
      { name: 'JIM', value: 5 },
      { name: 'HG', value: 6 }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    category (state) { return state.category }
  }
}



// WEBPACK FOOTER //
// ./src/store/documents.js